import { type SerializedPageStructure } from '@wix/document-services-types'
import { USER_INPUT_FILTER_DROPDOWN_ROLE } from '@wix/wix-data-client-common-standalone'

import { modifyConnectionConfigOfComponentAndControllerWithVeloIds } from './utils'
import { FILTER_DATASET_VELO_ID } from './veloIds'

export const rebindItemSelector = ({
  page,
  displayFieldKey,
}: {
  page: SerializedPageStructure
  displayFieldKey: string
}): SerializedPageStructure =>
  modifyConnectionConfigOfComponentAndControllerWithVeloIds({
    page,
    componentVeloId: 'itemSelector',
    controllerVeloId: FILTER_DATASET_VELO_ID,
    role: USER_INPUT_FILTER_DROPDOWN_ROLE,
    modifyConnectionConfig: config => ({
      ...config,
      userInputFilter: {
        ...config.userInputFilter,
        fieldName: displayFieldKey,
      },
    }),
  })
